import { useEffect, useState } from "react";

import { Dropdown } from 'primereact/dropdown';

import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { Calendar } from "primereact/calendar";
import useToast from "../../../hooks/ToastHook";

const installmentsOptions = Array.from({length: 120}, (_, i) => i + 1)
const todayDate = new Date()

const SelectInstallmentsSidebar = ({ setFormData, formData, hideSidebar }) => {
  const [installmentsQuantity, setInstallmentsQuantity] = useState(formData?.length || 1);
  const [billingData, setBillingData] = useState({ installments: formData || [] });
  const { showSuccess, showError } = useToast();

  const updateInstallment = (index, data) => {
    const updatedInstallments = billingData.installments.map((installment, i) => {
      if(i === index) {
        return {
          ...data,
          number: i,
        }
      }

      return {
        ...installment,
        number: i,
      }
    })

    setBillingData({
      ...billingData,
      installments: updatedInstallments
    })
  }

  const handleInstallmentsSave = () => {
    const allInstallmentsFilled = billingData.installments.every(installment => installment.value && installment.expiration)

    if(!allInstallmentsFilled) {
      showError('Erro', 'Preencha todos os campos para salvar as parcelas.')
      return
    }

    setFormData(billingData.installments)
    showSuccess('Sucesso', 'Parcelas salvas com sucesso.');
  }

  useEffect(() => {
    const installments = Array.from({length: installmentsQuantity}, (_, i) => ({
      value: null,
      expiration: null
    }))

    billingData.installments.forEach((installment, index) => {
      if(index < installmentsQuantity) {
        installments[index] = installment
      }
    })
    
    setBillingData({
      ...billingData,
      installments
    })
  }
  , [installmentsQuantity])

  return (
    <>
      <h1 className="text-gray-900 text-4xl font-semibold">Configurar parcelas</h1>
    
      <div className="grid gap-y-4">
        <div className="field col-12">
          <label

            htmlFor="installmentsQuantity"
            className="text-gray-500 text-base"
          >
            Quantidade de parcelas
          </label>

          <Dropdown
            id="paymentMethod"
            value={installmentsQuantity}
            onChange={(e) => setInstallmentsQuantity(e.value)}
            options={installmentsOptions}
            className="w-full"
          />
        </div>

        {billingData?.installments?.map((installment, index) => (
          <>
            <div className="field col-6">
              <label 
                htmlFor={`installmentValue${index}`} 
                className="text-gray-500 text-base"
              >
                Valor da {index + 1} parcela
              </label>
              
              <InputNumber
                id={`installmentValue${index}`}
                value={installment?.value}
                locale="pt-BR"
                mode="currency" 
                currency="BRL"
                maxFractionDigits={5}
                min={0}
                onChange={e => updateInstallment(index, {
                  ...billingData?.installments?.[index],
                  value: e.value
                })}
                className="w-full"
              />
            </div>

            <div className="field col-6">
              <label 
                htmlFor={`installmentDuedate${index}`} 
                className="text-gray-500 text-base"
              >
                Data de vencimento
              </label>
              
              <Calendar
                id={`installmentDuedate${index}`} 
                value={installment?.expiration} 
                onChange={(e) => updateInstallment(index, {
                  ...billingData?.installments?.[index],
                  expiration: e.value
                })} 
                dateFormat="dd/mm/yy" 
                className="w-full"
                minDate={todayDate}
              />
            </div>
          </>
        ))}

        <div className="w-full flex gap-4 bottom-0 bg-white py-3 flex-grow-0">
          <Button 
              className="w-full"
              label="Salvar"
              onClick={() => {
                handleInstallmentsSave()
                hideSidebar()
              }}
          />

          <Button 
              className="w-full"
              label="Cancelar" 
              outlined 
              type="button" 
              onClick={() => {
                setBillingData({ installments: [] })
                hideSidebar()
              }} 
          />
        </div>
      </div>
    </>
  )
}
        
const BillingInformation = ({
  billingData,
  setBillingData
}) => {
  const [paymentMethodSelect, setPaymentMethodSelect] = useState(null);
  const [paymentTypeSelect, setPaymentTypeSelect] = useState(null);
  const [selectInstallments, setSelectInstallments] = useState(null);

  const setFormData = (data) => {
    setBillingData({
      ...billingData,
      charge: {
        ...billingData?.charge,
        installments: data
      }
    })
  }

  return (
    <div className="grid gap-y-4">
      <div className="field col-12">
        <label 
          htmlFor="number" 
          className="text-gray-500 text-base"
        >
          Número da Fatura
        </label>

        <InputNumber
          id="number"
          value={Number(billingData?.charge?.number) || null}
          useGrouping={false}
          onChange={e => setBillingData({
            ...billingData,
            charge: {
              ...billingData?.charge,
              number: e?.value?.toString()
            }
          })}
          className="w-full"
        />
      </div>


      <div className="field col-4">
        <label 
          htmlFor="originalValue" 
          className="text-gray-500 text-base"
        >
          Valor original da fatura
        </label>
        
        <InputNumber
            id="originalValue"
            value={billingData?.charge?.originalValue}
            locale="pt-BR"
            mode="currency" 
            currency="BRL"
            maxFractionDigits={5}
            min={0}
            onChange={e => setBillingData({
              ...billingData,
              charge: {
                ...billingData?.charge,
                originalValue: e.value
              }
            })}
            className="w-full"
          />
      </div>

      <div className="field col-2">
        <label 
          htmlFor="discount" 
          className="text-gray-500 text-base"
        >
          Valor do desconto
        </label>
        
        <InputNumber
            id="discount"
            value={billingData?.charge?.discount}
            locale="pt-BR"
            mode="currency" 
            currency="BRL"
            maxFractionDigits={5}
            min={0}
            onChange={e => setBillingData({
              ...billingData,
              charge: {
                ...billingData?.charge,
                discount: e.value
              }
            })}
            className="w-full"
          />
      </div>

      <div className="field col-2">
        <label 
          htmlFor="discount" 
          className="text-gray-500 text-base"
        >
          Porcentagem do desconto
        </label>
        
        <InputNumber
            id="discount"
            value={billingData?.charge?.discount / billingData?.charge?.originalValue * 100 || 0}
            locale="pt-BR"
            maxFractionDigits={5}
            min={0}
            suffix=" %"
            onChange={e => setBillingData({
              ...billingData,
              charge: {
                ...billingData?.charge,
                discount: (e.value / 100) * billingData?.charge?.originalValue || 0
              }
            })}
            className="w-full"
          />
      </div>

      <div className="field col-4">
        <label 
          htmlFor="finalValue" 
          className="text-gray-500 text-base"
        >
          Valor líquido
        </label>
        
        <InputNumber
            id="finalValue"
            value={(billingData?.charge?.originalValue - billingData?.charge?.discount) || 0}
            locale="pt-BR"
            mode="currency" 
            currency="BRL"
            readOnly
            disabled
            className="w-full"
          />
      </div>

      <div className="field col-4">
        <label 
          htmlFor="paymentMethod" 
          className="text-gray-500 text-base"
        >
          Forma de pagamento
        </label>
        
        <Dropdown
          id="paymentMethod"
          value={paymentMethodSelect}
          onChange={(e) => {
            setPaymentMethodSelect(e.value)

            setBillingData({
              ...billingData,
              charge: {
                ...billingData?.charge,
                paymentMethod: {
                  code: e.value?.code,
                }
              }
            })
          }}
          options={[
            {label: 'Depósito', value: {code: '16', label: 'Depósito'}},
            {label: 'Transferencia bancária', value: {code: '18', label: 'Transferencia bancária'}},
            {label: 'Pix', value: {code: '17', label: 'Pix'}},
            {label: 'Boleto', value: {code: '15', label: 'Boleto'}},
          ]} 
          optionLabel="label"
          className="w-full"
        />
      </div>

      <div className="field col-4">
        <label 
          htmlFor="paymentType" 
          className="text-gray-500 text-base"
        >
          Tipo de pagamento
        </label>
        
        <Dropdown
          id="paymentType"
          value={paymentTypeSelect}
          onChange={(e) => {
            setPaymentTypeSelect(e.value)

            setBillingData({
              ...billingData,
              charge: {
                ...billingData?.charge,
                paymentType: {
                  code: e.value?.code,
                }
              }
            })
          }}
          options={[
            {label: 'À vista', value: {code: '0', label: 'À vista'}},
            {label: 'À prazo', value: {code: '1', label: 'À prazo'}},
          ]} 
          optionLabel="label"
          className="w-full"
        />
      </div>

      {paymentTypeSelect?.code === '1' && (
        <>
          <div className="field col-12">
            <Button 
              label="Configurar parcelas" 
              severity="secondary"
              type="button" 
              onClick={() => setSelectInstallments(true)} 
              className="w-full"
            />
          </div>

          <Sidebar 
              className="w-4 relative"
              position="right" 
              visible={selectInstallments} 
              onHide={() => setSelectInstallments(false)}
          > 
              <SelectInstallmentsSidebar 
                setFormData={setFormData}
                formData={billingData?.installments}
                hideSidebar={() => setSelectInstallments(false)} 
              />
          </Sidebar>
        </>
      )}
    </div>
  );
}

export default BillingInformation;